import { useContext, useMemo } from 'react';
import { type CurrentUserDataFragment } from '../../../api/fragments/CurrentUserData';
import { type Maybe } from '../../../api/types';
import getTokenData from '../../../utilities/getTokenData';
import { AccountContext } from './Context';

export const useAccountContext = () => {
    const context = useContext(AccountContext);

    if (!context) {
        throw new Error('Account context missing');
    }

    return context;
};

export const useSessionID = () => {
    const { token } = useAccountContext();

    return useMemo(() => {
        if (!token) {
            return null;
        }

        // get the session ID from the token
        // as it's EJSON we can find the stringify OID in $oid
        return getTokenData(token).sessionId?.$oid;
    }, [token]);
};

/* eslint-disable no-redeclare */
export function useAccount(optional: true): Maybe<CurrentUserDataFragment>;
export function useAccount(optional?: false): CurrentUserDataFragment;
export function useAccount(optional?: boolean): CurrentUserDataFragment {
    const { data } = useAccountContext();

    if (!optional && !data) {
        throw new Error('User data is missing');
    }

    return data;
}
/* eslint-enable no-redeclare */
